import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const MultiSelector = ({ name, onChange, options, value, arrowRenderer }) => (
  <div className={`option-selector ${name}`}>
    <Select
      autoBlur
      name={name}
      value={value}
      options={options}
      onChange={newObj => {
        onChange(name, newObj.split(','));
      }}
      multi
      simpleValue
      clearable={false}
      searchable={false}
      arrowRenderer={arrowRenderer}
    />
  </div>
);

MultiSelector.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  arrowRenderer: PropTypes.func
};

export default MultiSelector;



// WEBPACK FOOTER //
// ./src/components/MultiSelector/MultiSelector.js


// WEBPACK FOOTER //
// webpack:///src/components/MultiSelector/MultiSelector.js